import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
export const styles = stylex.create({
  departmentNode: {
    display: 'flex',
    paddingLeft: '20px',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
    boxSizing: 'border-box',
    alignSelf: 'stretch',
  },
  departmentHeader: {
    display: 'flex',
    padding: '8px 60px 8px 8px',
    alignItems: 'flex-start',
    gap: '24px',
    width: '100%',
    alignSelf: 'stretch',
  },
  departmentArrow: {
    display: 'flex',
    width: '20px',
    height: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  departmentHeaderW: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '8px',
  },
  departmentTitle: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '20px',
    color: colors.primaryText,
  },
  departmentChildren: {
    paddingLeft: '12px',
    gap: '12px',
    borderLeft: '1px solid #D0D5DD',
    width: '100%',
    boxSizing: 'border-box',
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px 4px 8px 4px',
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
  },
  checkboxTicket: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    marginTop: '10px',
  },
  vector: {
    width: '18px',
    display: 'flex',
    justifyContent: 'flex-end',
  },

  chevronOpen: {
    transform: 'rotate(0deg)',
  },

  chevronClosed: {
    transform: 'rotate(-90deg)',
  },
});
